<template>
  <div class="step thankyou-wrapper">
    <div class="step__body">
      <h3 class="step__title">Unfortunately this government program is not available in your area.
        <div class="step__subtitle">
          However, we found <b>(1) government program</b> that is available and can help you save up to $4,264 each year. Click below to find out more about it.
      </div></h3>
      <button
        type="button"
        class="btn btn--fill btn--blue btn--arrow cta"
        @click="goTo"
      >Continue
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    camp: {
      type: String,
      default: ''
    }
  },
  methods: {
    goTo () {
      window.location = `http://click.gospect.com/33d2b2a8-55e9-434c-902b-bb84ce7bf161?camp=${this.camp}`
    }
  }
}
</script>

<style scoped>

</style>
